(() => {
  if (window.satisfactionGuaranteeReady) return;
  window.satisfactionGuaranteeReady = true;

  class SatisfactionGuarantee {
    constructor() {
      document.addEventListener("click", (event) => this.handleClick(event));
    }

    handleClick(event) {
      const button = event.target.closest(".guarantee-section__cta[data-scroll-to-first-section='true']");

      if (!button) return;

      event.preventDefault();
      this.scrollToProduct();
    }

    scrollToProduct() {
      const productSection = document.querySelector(
        ".shopify-section .product, " +
          '.shopify-section [data-section-type="product"], ' +
          "main#MainContent .product-template, " +
          "main#MainContent .product, " +
          "#ProductSection, " +
          "#shopify-section-product-template, " +
          ".product-section",
      );

      if (productSection) {
        productSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  }

  new SatisfactionGuarantee();
})();
